import {gsap} from "../LibrariesImport";

export default class DataAppearOnScroll {
	constructor() {
		const items = document.querySelectorAll("[data-aos]");

		items.forEach((item) => {
			// Attribut HTML `data-aos-delay`
			const delay = item.dataset.aosDelay ?? 0;

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					start: "top 90%"
				},
			});

			// Animation vide avec un délai pour appliquer la classe "appeared"
			timeline.to(item, {
				delay: parseFloat(delay),
				duration: 0,
				onComplete: () => item.classList.add("appeared")
			});
		});
	}
}
